import { useMemo } from 'react';

import useFilterManager from '@/components/FilterManager/useFilterManager';
import { RootActionItemFilter } from '@/types/schema';

import { FileFragment } from '../../graphql/fragments/generated/file';
import { useFileQuery } from '../../graphql/queries/generated/file';

export default function useFile({ fileId }: { fileId?: string | null }) {
  const { state } = useFilterManager({});
  const viewValue = state.filter?.view;
  const rootActionItemStatus = viewValue == 'Separate' ? RootActionItemFilter.Both : undefined;
  const [{ data, fetching, error }] = useFileQuery({
    variables: {
      filters: {
        id: fileId!,
      },
      rootActionItemStatus,
    },
    pause: !fileId,
  });

  const file = useMemo(() => data?.file as FileFragment | undefined, [data?.file]);

  return { fetching, file, error };
}
